<app-form-field-render [field]="self" [suffix]="iconSuffixTmpl">
  <input
    readonly
    type="text"
    class="form-control"
    [class.is-invalid]="isTouchedInvalid"
    [placeholder]="placeholder || ''"
    [value]="getInputText | call: ctrl.value"
    [ngbPopover]="tmplDateRangePicker"
    #popoverDatePicker="ngbPopover"
    popoverClass="popover-auto-size no-body-padding"
    container="body"
    autoClose="outside"
    (hidden)="onClose()"
    (shown)="onOpen()"
  />
</app-form-field-render>

<ng-template #tmplDateRangePicker>
  <app-date-range-picker
    [selection]="ctrl.value"
    (selectionChange)="onDateRangeChange($event); popoverDatePicker.close()"
    [maxDate]="maxDate"
    [minDate]="minDate"
    [startDate]="startDate"
    [allowSingleDay]="allowSingleDay"
    (click)="$event.stopPropagation()"
  >
  </app-date-range-picker>
</ng-template>

<ng-template #iconSuffixTmpl>
  <form-field-affix (click)="popoverDatePicker.toggle()">
    <i class="far fa-calendar-day"></i>
  </form-field-affix>
</ng-template>
